// Cấu hình các hằng số dùng chung
export const BOOKING_STATUS_OPTIONS = [
    { value: 'PENDING', label: 'Chờ xử lý / Báo giá', color: 'warning' },
    { value: 'CONFIRMED', label: 'Khách Xác nhận', color: 'success' },
    { value: 'CANCELLED', label: 'Đã hủy', color: 'error' },
    { value: 'LOST', label: 'Deal hỏng', color: 'default' },
    { value: 'CLOSED', label: 'Hoàn thành', color: 'info' }
];

export const OPS_STATUS_OPTIONS = [
    { value: 'OPEN', label: 'Chờ điều hành' },
    { value: 'CONTACTED', label: 'Đã liên hệ NCC' },
    { value: 'CONFIRMED', label: 'NCC Đã xác nhận' },
    { value: 'OPERATING', label: 'Đang đi tour' },
    { value: 'DONE', label: 'Đã đi xong' }
];

export const INITIAL_STATE = {
    booking_code: '',
    booking_category: 'TOUR',       // Thêm dòng này
    booking_type: 'DIRECT',         // Thêm dòng này
    duration_days_actual: 1,        // Thêm dòng này
    customer: null,
    tour: null,
    sale_owner: '',
    start_date: new Date().toISOString().split('T')[0], // YYYY-MM-DD
    booking_status: 'PENDING',
    operation_status: 'OPEN',
    source: '',
    customer_demand: 'LE',
    adults_count: 1,
    children_count: 0,
    special_request: '',
    operator_notes: '',
    customer_feedback: '', 
    total_price: 0,
    payment_status: 'UNPAID',
    deposit_bill_image: null,
    payment_bill_image: null,
    tour_bill_image: null,
    guests: [],
    transports: [],
    rooms: [],
    extras: [],
    collections: [],
    tour_note: '',
    payable_status_tour: 'UNPAID',
    net_tour_price: 0,
};

export const COMMON_OPS_STATUS_OPTIONS = [
    { value: 'OPEN', label: 'Chờ xử lý' },
    { value: 'CONTACTED', label: 'Đã báo NCC' },
    { value: 'CONFIRMED', label: 'NCC Xác nhận' },
    { value: 'DONE', label: 'Hoàn tất' }
];

export const ITEM_TEMPLATES = {
    guest: { name: '', guest_type: 'ADULT', dob: null, nationality: '', passport: '' },
    transport: {
        supplier: null, vehicle_type: 'LIMO', payment_method: 'SEPARATE',
        direction: 'ROUND_TRIP', driver_info: '', pickup_point: '',
        pickup_datetime: '', payment_status: 'UNPAID',
        cost_price: 0, cost_original: 0, cost_currency: 'VND', cost_rate: 1,
        bill_image: null, note: ''
    },
    room: {
        room_type: '', quantity: 1, supplier: null, payment_method: 'INCLUDED',
        cost_price: 0, cost_original: 0, cost_currency: 'VND', cost_rate: 1,
        selling_price: 0, selling_original: 0, selling_currency: 'VND', selling_rate: 1, 
        note: '', payment_status: 'UNPAID', note_payment: ''
    },
    extra: {
        title: '', quantity: 1, supplier: null, payment_method: 'SEPARATE', // Default Separate cho Extra
        cost_price: 0, cost_original: 0, cost_currency: 'VND', cost_rate: 1,
        selling_price: 0, selling_original: 0, selling_currency: 'VND', selling_rate: 1, 
        note: '', payment_status: 'UNPAID'
    }
};